import React, { useState, useEffect, Fragment, useCallback } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import {
  Button,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import {
  LocalService,
  LoginService,
  SubscriptionService,
  SUBSCRIPTION_CHANGED_EVENT,
} from '../../core/services';
import ClanConnectLogo from '../../assets/images/clan_connect_logo.png';
import './header.scss';
import './brand-header.scss';
import { DefaultUserProfile } from '../../config/config';
import { SubscriptionDetail, setCart, setGuestUser } from '../../redux/action';
import { useCart } from '../../hooks/useCart';
import { BrandHeaderMenu, InfluencerHeaderMenu } from '../../data/data';
import { AnimatePresence, motion } from 'framer-motion';
import SampleProfile from '../../assets/images/avtar_male.png';
import CommonPopUp from '../popup/common-popup';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { LetUsHelpYou } from '../let-us-help-you/let-us-help-you';
import { HelpRequestSheet } from '../../modules/brand/components/settings/HelpRequestSheet';
import { BASE_URL_WEB } from '../../config/config';
import { BASE_URL_UI } from '../../config/config';
import  UpgradeBrandPopUp from '../popup/upgrade-brand-popup'
import  UpgradeInfluencerPopUp from '../popup/upgrade-influencer-popup'
import MaterialSymbol from '../icons/material-symbol';
import * as gtUtil from "../../core/utility";
import  HeaderLeft from './header-left';
import HeaderRight from './header-right';
import { useIsUSInfluencer } from '../../hooks/useIsUSInfluencer';
import { infPaths } from '../../modules/influencer/routes';
import { isTalentPartnerOnCreator, usesInfluencerFlow } from '../../modules/influencer/flowUser';

const subscriptionService: SubscriptionService = new SubscriptionService();

const localService = new LocalService();
const loginService = new LoginService();
const agencyUrls = [
  '/agency/settings/personal-info',
  '/agency/settings/companydetails',
  '/agency/settings/security',
  '/agency/settings/subscription',
  '/agency/settings/subscription-history',
  '/agency/settings/notifications',
  '/brand/admin-dashboard/influencer-signups',
  '/brand/admin-dashboard',
  '/brand/admin-dashboard/userbase',
  '/brand/admin-dashboard/campaign-verification',
  '/brand/admin-dashboard/campaign-details',
  '/brand/admin-dashboard/influencer-db',
  '/brand/admin-dashboard/crud',
  '/brand/admin-dashboard/agency-brands'
];

const talentPartnerUrls = [
  '/talent-partner/settings/personal-info',
  '/talent-partner/settings/companydetails',
  '/talent-partner/settings/brand-list',
  '/talent-partner/settings/security',
  '/talent-partner/settings/subscription',
  '/talent-partner/settings/subscription-history',
  '/talent-partner/settings/notifications'
];


const brandUrls = [

  '/brand/admin-dashboard/influencer-signups'
];

const brandDashboardUrls = [

  '/brand/dashboard'
];

const baseUrls = ['/switch/account', '/switch/user'];
interface Props {
  isLogin: any;
  UserReducer: any;
  guest_user: any;
  user_email_id: any;
  CartReducer: any;
  updateSubscriptionDetail?: (data: any) => void;
  getSubscriptionDetail: any;
  accounts: any;
  switchLayer2: any;
  switchLayer1: any;
}

function logoNavigate<Props>(props: Props) {
  // console.log(props);
}

const Header: React.FC<Props> = ({ accounts, ...props }: Props) => {
  useCart();
  const isUSInfluencer = useIsUSInfluencer();
  const [toggles, setToggles] = useState(false);
  const [profileMenu, setProfileMenu] = useState(false);
  const body = document.body;
  const scrollUp = 'scroll-up';
  const scrollDown = 'scroll-down';
  const dispatch = useDispatch<any>();
  let lastScroll = 0;
  const product_ids = localService.getStorageItem('product_id');
  const navigate = useNavigate();
  const location = useLocation();
  // const hideHeader = location.pathname.startsWith('/shop') || location.pathname.startsWith('/bio');
  // /form/:slug is the public Zap sign-up form — no site chrome, like /bio.
  // /subscription is the app's keyed checkout — no site menu (its Login / Sign up
  // would only lead the app user away from paying).
  const hideHeader = location.pathname.startsWith('/shop') || location.pathname.startsWith('/bio') || location.pathname.startsWith('/form/') || location.pathname === '/subscription';
  const isClanshopUrl = location.pathname.includes('/clanshop');
  const [isAnimating, setIsAnimating] = useState(false);
  const [isBasicUser, setBasicUser] = useState(false);
  const [disableHeaderonPath] = useState(['welcome'])
  const [validUrls, setValidUrls] = useState<any>([...baseUrls]);
  const [headerPictureUrl, setHeaderPictureUrl] = useState(DefaultUserProfile.influencer_unknown_default);
  const [openModal, setOpenModal] = useState(false);
  const showLoginSignUp = location.pathname !== '/subscription/invoice';

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
      body.classList.remove(scrollUp);
      body.classList.remove(scrollDown);
      return;
    }
    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if (
      currentScroll < lastScroll &&
      body.classList.contains(scrollDown)
    ) {
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  });
  const user_email_id: any = localService.getStorageItem('user_email_id');
  const guest_user_login = localService.getStorageItem('guest_user_login');
  if (guest_user_login) {
    dispatch(setGuestUser(true));
  }

  // set upgrade influencer Modal variables and usestate
  // const [openUpgradeInfluencerModal, setopenUpgradeInfluencerModal] = useState(false);
  const [openUpgradeBrandInboxModal, setopenUpgradeBrandInboxModal] = useState(false);
  const [openUpgradeInfluencerInboxModal, setopenUpgradeInfluencerInboxModal] = useState(false);

  async function getLeftDays() {
    const { account_id, user_id, influencer_id } = props.UserReducer;
    try {
      const response: any =
        await subscriptionService.getSubscription_Remaining_Days({
          account_id: account_id,
          user_id: user_id,
          influencer_id: influencer_id
        });
      if (response.status === gtUtil.Constants.SUCCESS) {
        //update subscription details
        if (props.updateSubscriptionDetail) {
          setBasicUser(false);
          props.updateSubscriptionDetail(response?.data?.rows[0] || null);
        }
      } else {
        setBasicUser(true);
        if (props.updateSubscriptionDetail) {
          props.updateSubscriptionDetail(response?.data?.rows[0] || null);
        }
      }
    } catch (error) {
      console.log('Influencer, TP, Header Error :: ' + JSON.stringify(error));
    }
  }

  useEffect(() => {
    // To show props.UserReducer?.photo or props.UserReducer?.gcp_profile_image_url if present
    if (![undefined, null, ""].includes(props.UserReducer?.photo)) {
      setHeaderPictureUrl(props.UserReducer?.photo);
    } else if (![undefined, null, ""].includes(props.UserReducer?.gcp_profile_image_url)) {
      setHeaderPictureUrl(props.UserReducer?.gcp_profile_image_url);
    }

    if (props.UserReducer && props.UserReducer.account_id && props.UserReducer.user_id && props.UserReducer.influencer_id) {
      getLeftDays();
    }

    if (props.UserReducer?.account_type === "Agency") {
      setValidUrls((prev:any) => [
        ...(prev || []),
        ...(agencyUrls || [])
      ]);
    }

    if (props.UserReducer?.account_type === "Talent Partner") {
      setValidUrls((prev:any) => [
        ...(prev || []),
        ...(talentPartnerUrls || [])
      ]);
    }
  }, [props.UserReducer, dispatch]);

  // Refresh the plan badge in place when the plan changes elsewhere in the app.
  //
  // The effect above is keyed on UserReducer, which claiming the free trial (or
  // completing a purchase) never touches — so the header kept rendering
  // "Upgrade" until some later navigation remounted it. Any page that changes
  // the plan calls notifySubscriptionChanged(); this re-runs the same fetch the
  // header already uses, so isBasicUser and the remaining-days label both
  // update without a reload.
  useEffect(() => {
    const { account_id, user_id, influencer_id } = props.UserReducer || {};
    if (!account_id || !user_id || !influencer_id) return;

    const onSubscriptionChanged = () => { getLeftDays(); };
    window.addEventListener(SUBSCRIPTION_CHANGED_EVENT, onSubscriptionChanged);
    return () => window.removeEventListener(SUBSCRIPTION_CHANGED_EVENT, onSubscriptionChanged);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.UserReducer]);

  const toggle = () => {
    setToggles((prevState) => !prevState);
  };
  const [selectedIndex, setSelectedIndex] = useState(1);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
  };
  const handleNavigation = () => {
     const account_type = props.UserReducer?.account_type;

    if (account_type  === 'Influencer') {
      navigate('/influencer/settings/subscription');
    } 
    else if (account_type   === 'Agency') {
      navigate('/brand/settings/subscription');
    } 
    else if (account_type   === 'Talent Partner') {
      // The picked creator's plans; with no creator picked, the list of their
      // creators' plans (each row's Upgrade Now buys for that creator).
      navigate(isTalentPartnerOnCreator(props.UserReducer, props.switchLayer2) ? '/influencer/settings/subscription' : '/talent-partner/settings/subscription');
    } 
    else {
      // Brands: the new campaign flow's Subscription page (the brand app's).
      navigate('/brand/profile/subscription');
    }
  };
  let BrandMenu = props?.UserReducer?.view_admin_dashboard === "True" ? BrandHeaderMenu.mainMenu : (props?.UserReducer?.brand_pulse === "True" ? BrandHeaderMenu.mainMenu.filter((item: any) => (item.id !== 6) ):BrandHeaderMenu.mainMenu.filter((item: any) => (item.id !== 6 && item.id !== 8) ));
  let InfluencerMenu = props?.UserReducer?.view_admin_dashboard === "True" ? InfluencerHeaderMenu.mainMenu : InfluencerHeaderMenu.mainMenu.filter((item: any) => (item.id !== 6 && item.id !== 8));
  // A Talent Partner gets Zap for the creator they picked on /switch/user (it is
  // that creator's: TalentPartnerCreatorGate); before a pick there is no creator.
  InfluencerMenu = props.UserReducer?.account_type === "Talent Partner" && !isTalentPartnerOnCreator(props.UserReducer, props.switchLayer2) ? InfluencerMenu.filter((item: any) => (item.id !== 4)) : InfluencerMenu;
  // US influencers only get Zap in the top nav (Settings lives in the profile dropdown, unaffected)
  InfluencerMenu = isUSInfluencer ? InfluencerMenu.filter((item: any) => (item.id === 4)) : InfluencerMenu;
  // Affiliate Deals is admin-only — show only to admin/super_admin (user_role_id 1 or 2),
  // the same gate used for Affiliate Pixel/My Storefront on the brand dashboard.
  InfluencerMenu = [1, 2].includes(props?.UserReducer?.user_role_id) ? InfluencerMenu : InfluencerMenu.filter((item: any) => (item.id !== 10));
  // To filter Influencer Tools header for production
  // InfluencerMenu = (BASE_URL_UI.includes('app.clanconnect.ai')) ? InfluencerMenu.filter((item: any) => item.id !== 4) : InfluencerMenu;
  // Influencers, and Talent Partners inside a picked creator: Dashboard, My
  // Campaigns and Inbox open the new campaign flow (modules/influencer).
  const influencerFlow = !!props.isLogin && usesInfluencerFlow(props.UserReducer, props.switchLayer2);
  if (influencerFlow) {
    const newFlowUrls: Record<number, string> = { 1: infPaths.home(), 2: infPaths.myCampaigns(), 5: infPaths.chats() };
    InfluencerMenu = InfluencerMenu.map((item: any) => (newFlowUrls[item.id] ? { ...item, url: newFlowUrls[item.id] } : item));
  }
  const isBrandAccount = !!props.isLogin && ['Brand', 'Agency'].includes(props?.UserReducer?.account_type);
  // Brands, agencies and influencers get the new flow's header look (brand-header.scss).
  const newHeaderLook = isBrandAccount || influencerFlow;
  const HeaderMenu = ['Brand', 'Agency'].includes(props?.UserReducer?.account_type) ? BrandMenu : InfluencerMenu
  // To Filter admin dashboard tab if permission not granted................
  const outsideClick = useCallback(() => {
    const handleOutsideClick = (event: any) => {
      const todoInputContainer = document.querySelector('._header_profile_picture');
      if (todoInputContainer && !todoInputContainer.contains(event.target)) {
        setProfileMenu(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [setProfileMenu]);

  useEffect(() => {
    const cleanup = outsideClick();

    return () => {
      cleanup();
    };
  }, [outsideClick]);

  const getDashboardLink = () => {
    if (isClanshopUrl && !props.isLogin  ) {
      return '/clanshop'; // Redirect to clanshop if isClanshopUrl is present
    } else {
      if (props.UserReducer?.account_type === 'Brand') {
        return '/brand/home';
      } else if (influencerFlow) {
        return isUSInfluencer ? '/influencer/zap' : infPaths.home();
      } else {
        return '/switch/user';
      }
    }
  };
  const listVars = {
    initial: {
      scale: 0,
      width: '10px',
      height: '10px',
      x: '0px',
      y: 0,

    },
    animate: {
      scale: 1,
      y: 20,
      transformOrigin: 'right top',
      width: '220px',
      height: 'auto',
      transition: {
        duration: 0.4,
        ease: [0.45, 0, 0.55, 1],
      },

    },
    exit: {
      scale: 0,
      x: '0',
      y: 0,
      width: '10px',
      height: '10px',
      transformOrigin: 'right top',
      transition: {
        delay: 0.4,
        duration: 0.3,
        ease: [0.22, 0, 0.39, 1],
      },
    }
  }


  const menuLinkVars = {
    initial: {
      y: "220px",
      transition: {
        duration: 0.5,
        ease: [0.37, 0, 0.63, 0.63]
      },
    },
    open: {
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0, 0.55, 0.45, 1]
      },
    }
  };
  const headerProfileToggle = () => {
    setProfileMenu(prev => !prev)
    setIsAnimating(isAnimating => !isAnimating)
  }

  const handleNavLinkClick = (menu: any) => {
    if (isBasicUser && (menu.title === 'Profile View' || menu.title === 'Inbox') 
      && (props.UserReducer.account_type == 'Influencer' || props.UserReducer.account_type == 'Talent Partner')) {
      setopenUpgradeInfluencerInboxModal(!openUpgradeInfluencerInboxModal);
    }
  };


  const onClose = (value: boolean) => {
    setOpenModal(value)
  }

  // CHECK THE USER TYPE IS TALENT PARTNER
  const shouldHideMenu = (
    (props?.UserReducer?.account_type === 'Talent Partner' && agencyUrls.includes(location.pathname)) || // Condition 1
    (props?.UserReducer?.account_type === 'Talent Partner' &&
      props?.UserReducer?.influencer_ids?.length > 1 &&
      agencyUrls.includes(location.pathname)) // Condition 2
  );


  const agencyPaths = ['/brand/dashboard', '/brand/list', '/brand/plans', '/brand/discover'];
  const talentPartnerPaths = ['/influencer/dashboard', '/influencer/mycampaigns', '/influencer/profile-view'];

  const isAgencyPath = props.UserReducer?.account_type === 'Agency' && agencyPaths.includes(location.pathname);
  const isTalentPartnerPath = props.UserReducer?.account_type === 'Talent Partner' && talentPartnerPaths.includes(location.pathname);




  return (
    <>
      {openUpgradeBrandInboxModal && (
        <>
        <UpgradeBrandPopUp
          openUpgradeBrandModal={openUpgradeBrandInboxModal}
          onClose={() => setopenUpgradeBrandInboxModal(!openUpgradeBrandInboxModal)}
          popupMinWidth='630px'
        >
        </UpgradeBrandPopUp>
        </>
      )}
       {openUpgradeInfluencerInboxModal && (
        <>
        <UpgradeInfluencerPopUp
          openUpgradeInfluencerModal={openUpgradeInfluencerInboxModal}
          onClose={() => setopenUpgradeInfluencerInboxModal(!openUpgradeInfluencerInboxModal)}
          popupMinWidth='630px'
        >
        </UpgradeInfluencerPopUp>
        </>
      )}
      {/* Header - Brand, Influencer, TP and Agency */}
      {!location.pathname.split('/').map(k => disableHeaderonPath.map(l => l === k)[0]).includes(true) && !hideHeader &&
        <header
          className={
            `${!props.isLogin ? 'site-header' : 'app-header_brand site-header'}${newHeaderLook ? ' brd-site-header' : ''} ${location.pathname} 
            ${influencerFlow && " d-none d-md-flex"}
            `
          }
        >
          <div className='container _header-container'>
            <HeaderLeft
              isLogin={props.isLogin}
              user={props.UserReducer}
              location={location}
              HeaderMenu={HeaderMenu}
              getDashboardLink={getDashboardLink}
            />

            <HeaderRight
              isLogin={props.isLogin}
              user={props.UserReducer}
              profileMenu={profileMenu}
              toggleProfile={headerProfileToggle}
              headerPictureUrl={headerPictureUrl}
              
              getSubscriptionDetail={props.getSubscriptionDetail}
              setOpenModal={setOpenModal}
              isBasicUser={isBasicUser}
              HeaderMenu={HeaderMenu}
              accounts={accounts}
              handleNavLinkClick={handleNavLinkClick}
              listVars={listVars}
              menuLinkVars={menuLinkVars}
              localService={localService}
              validUrls={validUrls}
              agencyUrls={agencyUrls}
              talentPartnerUrls={talentPartnerUrls}
              headerProfileToggle={headerProfileToggle}
              switchLayer2={props.switchLayer2}
              toggle={toggle}
              toggles={toggles}
              guest_user={props.guest_user}
              user_email_id={user_email_id}
              selectedIndex={selectedIndex}
              handleListItemClick={handleListItemClick}
              setToggles={setToggles}
              handleNavigation={handleNavigation}

            />
             {isBrandAccount ? (
               // Brands / agencies: the brand app's help form, in the new flow's pop-up.
               <HelpRequestSheet open={openModal} onClose={() => onClose(false)} />
             ) : (
             <CommonPopUp
                modalTitle="Let us help you"
                modalContent=""
                openModal={openModal}
                onClose={() => onClose(false)}
                className="modal-medium mx-auto"
              >
                <LetUsHelpYou userReducer={props.UserReducer} setOpenModal={setOpenModal} />
              </CommonPopUp>
             )}
          </div>
        </header>
      }
    </>
  );
};
/*
    Connect all type of headers with redux
*/

// Get Redux State Data

const mapStateToProps = (state: any) => {
  return {
    isLogin: state.UserReducer.IsUserLogged,
    UserReducer: state.UserReducer.UserData,
    guest_user: state.guestUserReducer.guest_user,
    user_email_id: state.guestUserReducer.user_email_id,
    CartReducer: state.CartReducer,
    getSubscriptionDetail: state.Subscription.subscription_detail,
    accounts: state.SwitchLayer1Reducer.switchAccount,
    switchLayer2: state.SwitchLayer2Reducer.switchUser,
    switchLayer1: state.SwitchLayer1Reducer.switchAccount,
  };
};

// Update Redux State

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateSubscriptionDetail: (data: any) => dispatch(SubscriptionDetail(data)),
  };
};

// Common Header
const Common = connect(mapStateToProps, mapDispatchToProps)(Header);
export { Common as Header };
